import QuotaTable from 'Components/QuotaTable';
import AdminHeader from 'Components/Admin/AdminHeader';
import { Block, ButtonSelect, CalendarHeader, Flex, Label, Toggle, Tooltip } from '@upsales/components';
import { getStartAndEndDate } from 'Store/actions/AdminGoalsActions';
import QuotaProductCategorySelect from 'App/pages/Admin/subPages/ProductQuota/QuotaProductCategorySelect';

ReactTemplates.admin.genericQuota = window.ReactCreateClass({
	getInitialState: function () {
		return {
			fullscreen: false
		};
	},
	UNSAFE_componentWillMount: function () {
		var t = Tools.$translate;

		this.lang = {
			showPreviousYear: t('admin.showPreviousYearActivity'),
			showTotalIn: t('admin.showTotalIn'),
			allUsers: t('filters.allUsers'),
			user: t('default.user'),
			role: t('default.role'),
			fullscreen: t('default.fullscreen'),
			showInactiveUsers: t('admin.includeInactiveAndDeletedUsers'),
			productOrCategory: t('admin.selectProductOrCategory'),
			productValue: t('admin.productQuota.productValue'),
			productQuantity: t('admin.productQuota.productQuantity')
		};
	},
	showPreviousYear: function () {
		this.props.rootData.filterChange('showPreviousYear', !this.props.rootData.pageData.showPreviousYear);
	},
	toggleShowInactiveUsers: function (checked) {
		this.props.rootData.filterChange('showInactiveUsers', checked);
	},
	yearChange: function (value) {
		let fullYear = null;
		if (value instanceof Array) {
			fullYear = value[1].getFullYear();
		} else {
			fullYear = value.getFullYear();
		}
		if (fullYear < 1970) {
			return;
		}

		const metadata = Tools.AppService.getMetadata();
		if (metadata.params.brokenFiscalYearEnabled) {
			const brokenFiscalYearOffset = metadata.params.brokenFiscalYearOffset;
			const yearOffset = brokenFiscalYearOffset > 0 ? -1 : 0;
			fullYear += yearOffset;
		}

		this.props.rootData.filterChange('year', fullYear);
	},
	currencyChange: function (e) {
		var defaultCurrency = _.find(this.props.rootData.pageData.currencies, { iso: e.target.value });
		this.props.rootData.filterChange('defaultCurrency', defaultCurrency);
	},
	productChange: function (value) {
		if (value.isProductCategory) {
			this.props.rootData.filterChange('productCategory', value);
			this.props.rootData.filterChange('product', null);
		} else {
			this.props.rootData.filterChange('product', value);
			this.props.rootData.filterChange('productCategory', null);
		}
	},
	toggleFullScreen: function () {
		this.setState({ fullscreen: !this.state.fullscreen });
	},
	userChange: function (user) {
		this.props.rootData.filterChange('user', user);
	},
	setRef: function (name, ref) {
		this[name] = ref;
	},

	render: function () {
		var loader = <ReactTemplates.loader />;
		var defaultCurrency = this.props.rootData.pageData.defaultCurrency;

		const metadata = Tools.AppService.getMetadata();
		const brokenFiscalYear = metadata.params.brokenFiscalYearEnabled;
		var t = Tools.$translate;

		const { quotaType, year, user, roleTree, product, productCategory, version } = this.props.rootData.pageData;

		const { start: startDate, end: endDate } = getStartAndEndDate(year);
		const selectedPeriod = brokenFiscalYear ? [startDate, endDate] : startDate;

		return (
			<div id="admin-page-activity-quota" className={this.state.fullscreen ? 'fullscreen visible' : 'visible'}>
				<AdminHeader
					title={this.props.rootData.pageData.title}
					description={this.props.rootData.pageData.description}
					image="sales-goals.svg"
					articleId={this.props.rootData.pageData.articleNo}
				/>

				<div id="admin-content">
					<div className="admin-section">
						<div className="admin-table" ref={this.setRef.bind(this, 'anchorRef')}>
							{!this.props.rootData.pageLoading && (
								<div className="table-tools">
									<Flex gap={'u3'}>
										<Block className="tool-filter">
											<Label>
												{this.lang.user}
												{'/'}
												{this.lang.role}
											</Label>
											<ReactTemplates.INPUTS.upUsers
												value={user}
												data={roleTree}
												tools={this.props.tools}
												placeholder={this.lang.allUsers}
												onChange={this.userChange}
											/>
										</Block>
										<Block className="tool-filter new-calendar-select year">
											<Label>{brokenFiscalYear ? t('date.fiscalyear') : t('date.year')}</Label>
											<CalendarHeader
												date={selectedPeriod}
												dateFormat={brokenFiscalYear ? 'YYYY MMM' : 'YYYY'}
												isMonthView
												autoAlign
												onDateChange={this.yearChange}
											/>
										</Block>
									</Flex>
									<Flex gap="u3" spacing="pt3" justifyContent="space-between" alignItems="flex-start">
										<Flex direction="column" flex={1} gap="u3">
											<Flex gap="u3">
												<Toggle
													checked={this.props.rootData.pageData.showInactiveUsers}
													onChange={this.toggleShowInactiveUsers}
												/>
												<Label>{this.lang.showInactiveUsers}</Label>
											</Flex>
											<Flex gap="u3">
												<Toggle
													checked={this.props.rootData.pageData.showPreviousYear}
													onChange={this.showPreviousYear}
												/>
												<Label>{this.lang.showPreviousYear}</Label>
											</Flex>
											{quotaType === 'productValue' || quotaType === 'productQuantity' ? (
												<>
													<Block className="tool-filter">
														<Label>{this.lang.productOrCategory}</Label>
														<QuotaProductCategorySelect
															required
															value={product || productCategory}
															quotaFilters={{ year, quotaType, version }}
															onChange={value => {
																if (value.isCategory) {
																	this.props.rootData.filterChange(
																		'productCategory',
																		value
																	);
																	this.props.rootData.filterChange('product', null);
																} else {
																	this.props.rootData.filterChange('product', value);
																	this.props.rootData.filterChange(
																		'productCategory',
																		null
																	);
																}
															}}
															anchor={this.anchorRef}
														/>
													</Block>
													<Block className="tool-filter">
														<ButtonSelect
															options={[
																{
																	title: this.lang.productValue,
																	value: 'productValue'
																},
																{
																	title: this.lang.productQuantity,
																	value: 'productQuantity'
																}
															]}
															value={quotaType}
															onChange={value =>
																this.props.rootData.filterChange('quotaType', value)
															}
														/>
													</Block>
												</>
											) : null}
										</Flex>
										<Block key="currency">
											<Label>{this.lang.showTotalIn}</Label>
											<ReactTemplates.INPUTS.upSelect
												className="form-control"
												data={_.map(this.props.rootData.pageData.currencies, function (y) {
													return { id: y.iso, name: y.iso };
												})}
												defaultValue={defaultCurrency.iso}
												required={true}
												onChange={this.currencyChange}
											/>
										</Block>
									</Flex>
									<Tooltip
										title={this.lang.fullscreen}
										position="left"
										style={{ top: '10px', right: '10px', position: 'absolute' }}
									>
										<button
											id="toggle-fullscreen"
											type="button"
											className="up-btn btn-grey btn-link"
											onClick={this.toggleFullScreen}
										>
											{!this.state.fullscreen ? (
												<b className="fa fa-expand" />
											) : (
												<b className="fa fa-compress" />
											)}
										</button>
									</Tooltip>
								</div>
							)}
							{!this.props.rootData.pageData.tableLoading ? <QuotaTable {...this.props} /> : null}
							<div className={!this.props.rootData.pageData.tableLoading ? 'hide' : ''}>{loader}</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
});
